// models the values from process env
export class Environment {
    public VGroupApiBaseUrl: string = '';
    public BlobStorageUrl: string = '';
    public AttributeImageContainer: string = '';
    public SignalREndpoint: string = '';
    public RecaptchaSiteKey: string = '';

    public get AttributeImageUrl(): string {
        return `${this.BlobStorageUrl}${this.AttributeImageContainer}/`;
    }
}
